import axios from 'axios'
import { COUNTRIES, TAGS } from './lookups'

export const HTTP = axios.create({
  baseURL: 'https://mevris-bridge.better-hotel.com/api/black-list/',
  // baseURL: 'http://localhost:8000/api/black-list/',
  // baseURL: 'http://10.6.40.47:8000/api/black-list/',
  // baseURL: 'http://192.168.1.199:8000/api/black-list/',
  // baseURL: 'http://31.10.62.147:8884/api/black-list/', // OPI
  responseType: 'json',
  timeout: 10000
  // withCredentials: true,
  // headers: {
  //   'X-Requested-With': 'XMLHttpRequest',
  //   'Accept': 'application/json, text/plain, */*',
  //   'Content-Type': 'application/json',
  //   // 'Access-Control-Allow-Origin': '*'
  //   // 'Access-Control-Allow-Origin': 'https://app.kdoprijel.cz'
  //   'Connection': 'keep-alive',
  //   'Access-Control-Allow-Origin': '*',
  //   'Access-Control-Allow-Methods': 'POST, PUT, DELETE, GET, OPTIONS',
  //   'Access-Control-Allow-Headers': '*'
  // }
})

export function getCountryFlagUrl (iso) {
  if (!COUNTRIES.has(iso)) {
    return ''
  }
  const country = COUNTRIES.get(iso)
  return 'static/img/flags/' + country.alpha2 + '.png'
}

export function getCountryName (vue, iso) {
  if (!COUNTRIES.has(iso)) {
    return ''
  }
  const country = COUNTRIES.get(iso)
  return vue.$t('country_' + country.alpha2)
}

export function getTagName (vue, code) {
  if (!TAGS.has(code)) {
    return ''
  }
  return vue.$t('tag_' + code)
}

export function getTagIconText (code) {
  if (!TAGS.has(code)) {
    return ''
  }
  return TAGS.get(code).icon_text
}

export function getTagIconUrl (code) {
  if (!TAGS.has(code)) {
    return ''
  }
  return 'static/img/tag_reason/' + code + '.png'
}

export function getHrefUrl (url) {
  if (!url) {
    return ''
  }
  return url.startsWith('http', true) ? url : 'http://' + url
}

export function showError (vue, message) {
  vue.$swal({
    position: 'bottom-right',
    type: 'error',
    title: vue.$t('error'),
    text: message,
    showConfirmButton: false,
    timer: 3000
  })
}



// WEBPACK FOOTER //
// ./src/utils/index.js